import React, { Component } from "react";
import styled, { keyframes } from "styled-components";


import {
  LargeTitle,
  ContainWPadding,
  HugeTitle,
  SmallTitle,
  primary,
  Margin,
  SmallMargin,
  SplashTitle,
  MediumTitle,
  LongArrowWhite,
  CookiesText
} from "../Tools/Variables";
import BgImg from "../Images/betongsang.jpg";
import Header, { HeaderHeight } from "../Global/Header";

const CookiesLine = styled.div`
width: 100%;
height: 2px;
background: ${primary};
margin: 0 20px;
`;

class Cookies extends Component {
  render() {
    return (
<div>
<div style={{background:'#222' , color:'white', height: HeaderHeight, display:'flex', alignItems:'center' }}>
<CookiesLine/>
<SmallTitle style={{margin:'0 30px'}}>Cookies</SmallTitle>
<CookiesLine/>
</div>
<Margin/>
        <ContainWPadding>
            <CookiesText/>
        </ContainWPadding>
</div>
    );
  }
}

export default Cookies;



// WEBPACK FOOTER //
// ./src/Global/Cookies.js